/**
 * @file Точка входа браузерного приложения.
 *
 * React подключается к контейнеру из index.html. StrictMode дополнительно
 * проверяет создание и очистку эффектов в режиме разработки.
 */
import React from 'react'
import ReactDOM from 'react-dom/client'

import Root from './Root'
import { takeOneTimeSignIn } from './features/session/oneTimeSignIn'
import './index.css'

// Убираем токен из URL до рендера и сохраняем только попытку входа в памяти.
// Выполняем один раз вне React: повторный запуск эффекта в StrictMode
// не должен читать уже очищенный адрес и создавать другую попытку.
const oneTimeSignIn = takeOneTimeSignIn(window.location, window.history)

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Root oneTimeSignIn={oneTimeSignIn} />
    </React.StrictMode>,
)
